import { DueDiligenceActionsService } from '@/modules/global-settings/onboarder/services/due-diligence-actions.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new dueDiligenceActionsService instance
const dueDiligenceService = new DueDiligenceActionsService();
// Due Diligence Actions Module State
export const state = {
  dueDiligenceActions: []
};
// Due Diligence Actions Module Mutations
export const mutations = {
  ...make.mutations(state)
};
// Due Diligence Actions Module Actions
export const actions = {
  /**
   * Create a new due diligence action
   * @param {Object} context - Vuex context object
   * @param {Object} payload - Payload object
   * @returns {Object} data - Due diligence action data
   * @private This will update the state
   */
  createDueDiligenceActions: async ({ dispatch }, payload) => {
    try {
      const { data } = await dueDiligenceService.createDueDiligenceActions(
        payload
      );
      dispatch('getDueDiligenceActions');
      return data;
    } catch (error) {
      Logger.error('creating due diligence action');
      throw error;
    }
  },

  /**
   * Fetch all due diligence actions
   * @param {Object} context - Vuex context object
   * @returns {Array} data - Due diligence action data
   * @private This will re-fetch the due diligence actions
   */
  getDueDiligenceActions: async ({ commit }) => {
    try {
      const { data } = await dueDiligenceService.getDueDiligenceActions();
      // Store the data in the state
      commit('SET_DUE_DILIGENCE_ACTIONS', data);
      return data;
    } catch (error) {
      Logger.error('getting due diligence action');
      throw error;
    }
  },

  /**
   * Update a due diligence action
   * @param {Object} context - Vuex context object
   * @param {Object} payload - Payload object
   * @returns {void}
   * @private This will re-fetch the due diligence actions
   */
  updateDueDiligenceActions: async ({ dispatch }, payload) => {
    try {
      await dueDiligenceService.updateDueDiligenceActions(payload);
      dispatch('getDueDiligenceActions');
    } catch (error) {
      Logger.error('updating due diligence action');
      throw error;
    }
  }
};

// generate getters with vuex-pathify - make function
export const getters = {
  ...make.getters(state),
  activeDueDiligenceActions(state) {
    return state.dueDiligenceActions.filter((d) => d.status == true);
  }
};
